import { render } from "./Exports.vue?vue&type=template&id=51e698b4"
import script from "./Exports.vue?vue&type=script&lang=js"
export * from "./Exports.vue?vue&type=script&lang=js"

import "./Exports.vue?vue&type=style&index=0&id=51e698b4&lang=css"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__